/*
 * art-wishlist — Merken-Herz (Wunschliste) für alle Seiten.
 * Toggelt .art-wish per localStorage und hält das Icon/State synchron.
 * Ein einziger delegierter Listener auf document — funktioniert für jedes
 * .art-wish-Element (Startseite, Kollektion, Header …). Wird global über
 * art-foundation geladen; daher NICHT zusätzlich pro Sektion einbinden.
 */
(function () {
  var KEY = 'art_wish';
  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function save(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function sync() {
    var saved = get();
    document.querySelectorAll('.art-wish').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-art-wish')) !== -1;
      b.classList.toggle('is-on', on);
      var i = b.querySelector('i');
      // Immer das Strich-Icon: die gefuellte Icon-Schrift (ph-fill) ist am 06.08.2026
      // entfallen, ein 'ph-fill'-Klassenname wuerde nur ein leeres Zeichen rendern.
      // Der gemerkte Zustand wird ueber .is-on (Farbe/Flaeche) sichtbar gemacht.
      if (i) i.className = 'ph ph-heart';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.art-wish');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var id = b.getAttribute('data-art-wish');
    if (!id) return;
    var a = get();
    var idx = a.indexOf(id);
    if (idx === -1) a.push(id); else a.splice(idx, 1);
    save(a);
    sync();
    document.dispatchEvent(new CustomEvent('art:wishlist:change', { detail: { count: a.length } }));
  });
  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
})();
